// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import ClassStep from "./class-step.js"
import Organization from "./organization.js"
import Tenant from "./tenant.js"

const modelClassData = {
  "attributes": {
    "class_step_id": {
      "column": {
        "default": null,
        "name": "class_step_id",
        "null": false,
        "type": "uuid"
      },
      "name": "class_step_id",
      "selected_by_default": null,
      "translated": null
    },
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "name": {
      "column": {
        "default": null,
        "name": "name",
        "null": true,
        "type": "string"
      },
      "name": "name",
      "selected_by_default": null,
      "translated": null
    },
    "teams_count": {
      "column": {
        "default": 0,
        "name": "teams_count",
        "null": false,
        "type": "integer"
      },
      "name": "teams_count",
      "selected_by_default": null,
      "translated": null
    },
    "team_surveys_count": {
      "column": {
        "default": 0,
        "name": "team_surveys_count",
        "null": false,
        "type": "integer"
      },
      "name": "team_surveys_count",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "SchoolClass",
  "collectionKey": "school_classes",
  "collectionName": "school_classes",
  "i18nKey": "school_class",
  "camelizedLower": "schoolClass",
  "name": "SchoolClass",
  "nameDasherized": "school-class",
  "pluralName": "school_classes",
  "ransackable_associations": [
    {
      "className": "ClassStep",
      "collectionName": "class_steps",
      "foreignKey": "class_step_id",
      "name": "class_step",
      "macro": "belongs_to",
      "resource_name": "ClassStep",
      "through": null
    },
    {
      "className": "ElectionPostSchoolClass",
      "collectionName": null,
      "foreignKey": "school_class_id",
      "name": "election_post_school_classes",
      "macro": "has_many",
      "resource_name": null,
      "through": null
    },
    {
      "className": "ElectionPost",
      "collectionName": "election_posts",
      "foreignKey": "election_post_id",
      "name": "election_posts",
      "macro": "has_many",
      "resource_name": "ElectionPost",
      "through": "election_post_school_classes"
    },
    {
      "className": "Election",
      "collectionName": "elections",
      "foreignKey": "election_id",
      "name": "elections",
      "macro": "has_many",
      "resource_name": "Election",
      "through": "election_posts"
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "Organization",
      "collectionName": "organizations",
      "foreignKey": "school_id",
      "name": "school",
      "macro": "belongs_to",
      "resource_name": "Organization",
      "through": null
    },
    {
      "className": "SchoolYear",
      "collectionName": "school_years",
      "foreignKey": "school_class_id",
      "name": "school_years",
      "macro": "has_many",
      "resource_name": "SchoolYear",
      "through": null
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "class_step_id",
      "column": {
        "default": null,
        "name": "class_step_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "end_date",
      "column": {
        "default": null,
        "name": "end_date",
        "null": true,
        "type": "date"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "name",
      "column": {
        "default": null,
        "name": "name",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "old_class_step_id",
      "column": {
        "default": null,
        "name": "old_class_step_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_id",
      "column": {
        "default": null,
        "name": "old_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_school_id",
      "column": {
        "default": null,
        "name": "old_school_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "school_id",
      "column": {
        "default": null,
        "name": "school_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "start_date",
      "column": {
        "default": null,
        "name": "start_date",
        "null": true,
        "type": "date"
      }
    },
    {
      "name": "team_surveys_count",
      "column": {
        "default": 0,
        "name": "team_surveys_count",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "teams_count",
      "column": {
        "default": 0,
        "name": "teams_count",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "uni_id",
      "column": {
        "default": null,
        "name": "uni_id",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [
    {
      "className": "ClassStep",
      "collectionName": "class_steps",
      "foreignKey": "class_step_id",
      "name": "class_step",
      "macro": "belongs_to",
      "resource_name": "ClassStep",
      "through": null
    },
    {
      "className": "Organization",
      "collectionName": "organizations",
      "foreignKey": "school_id",
      "name": "school",
      "macro": "belongs_to",
      "resource_name": "Organization",
      "through": null
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    }
  ],
  "paramKey": "school_class",
  "primaryKey": "id"
}

/** Frontend model for SchoolClass. */
export default class SchoolClass extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {string} */
  classStepId() {
    return this.readAttributeUnderscore("class_step_id")
  }

  /** @returns {boolean} */
  hasClassStepId() {
    const value = this.classStepId()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  name() {
    return this.readAttributeUnderscore("name")
  }

  /** @returns {boolean} */
  hasName() {
    const value = this.name()

    return this._isPresent(value)
  }

  /** @returns {number} */
  teamsCount() {
    return this.readAttributeUnderscore("teams_count")
  }

  /** @returns {boolean} */
  hasTeamsCount() {
    const value = this.teamsCount()

    return this._isPresent(value)
  }

  /** @returns {number} */
  teamSurveysCount() {
    return this.readAttributeUnderscore("team_surveys_count")
  }

  /** @returns {boolean} */
  hasTeamSurveysCount() {
    const value = this.teamSurveysCount()

    return this._isPresent(value)
  }

  /** @returns {import("./class-step.js").default | null} */
  classStep() {
    return this._readBelongsToReflection({modelClass: ClassStep, reflectionName: "class_step"})
  }

  /** @returns {Promise<import("./class-step.js").default | null>} */
  loadClassStep() {
    if (!("classStepId" in this)) throw new Error("Foreign key method wasn't defined: classStepId")

    const id = this.classStepId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "class_step",
        model: this,
        modelClass: ClassStep
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./class-step.js").default | null>} */
  ensureClassStepLoaded() {
    return this.ensureAssociationLoaded("class_step")
  }

  /** @returns {import("./organization.js").default | null} */
  school() {
    return this._readBelongsToReflection({modelClass: Organization, reflectionName: "school"})
  }

  /** @returns {Promise<import("./organization.js").default | null>} */
  loadSchool() {
    if (!("schoolId" in this)) throw new Error("Foreign key method wasn't defined: schoolId")

    const id = this.schoolId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "school",
        model: this,
        modelClass: Organization
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./organization.js").default | null>} */
  ensureSchoolLoaded() {
    return this.ensureAssociationLoaded("school")
  }

  /** @returns {import("./tenant.js").default | null} */
  tenant() {
    return this._readBelongsToReflection({modelClass: Tenant, reflectionName: "tenant"})
  }

  /** @returns {Promise<import("./tenant.js").default | null>} */
  loadTenant() {
    if (!("tenantId" in this)) throw new Error("Foreign key method wasn't defined: tenantId")

    const id = this.tenantId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "tenant",
        model: this,
        modelClass: Tenant
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./tenant.js").default | null>} */
  ensureTenantLoaded() {
    return this.ensureAssociationLoaded("tenant")
  }
}
